import './App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './components/Home/Home';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import AboutDetails from './components/About/AboutDetails';
import Contact from './components/Contact/Contact';
import Blog from './components/Blog/Blog';
import Main from './components/Layout/Main';
import AboutMe from './components/HomeAbout/AboutMe';
import HomeAboutSkill from './components/HomeAbout/HomeAboutSkill';
import HomeAboutService from './components/HomeAbout/HomeAboutService';
import HomeAboutAward from './components/HomeAbout/HomeAboutAward';
import HomeAboutInterview from './components/HomeAbout/HomeAboutInterview';
import NotFound from './components/NotFound/NotFound';

function App() {
  const router = createBrowserRouter([
    {
      path: '/', element: <Main />, errorElement: <NotFound />, children: [
        { path: '/', element: <Home />, children: [
          {path: '/' , element: <AboutMe />},
          {path: 'homeAboutSkill' , element: <HomeAboutSkill />},
          {path: 'homeAboutService' , element: <HomeAboutService />},
          {path: 'homeAboutInterview' , element: <HomeAboutInterview />},
          {path: 'homeAboutAward' , element: <HomeAboutAward />}
        ] },
        { path: 'service', element: <Services /> },
        { path: 'portfolio', element: <Portfolio /> },
        { path: 'about', element: <AboutDetails /> },
        { path: 'contact', element: <Contact /> },
        { path: 'blog', element: <Blog /> },
      ]
    },
  ])

  return (
    <RouterProvider router={router} />
  );
}

export default App;
